"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBTable = HBTable;
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactScrollSync = require("react-scroll-sync");
var _HBTableBody = _interopRequireDefault(require("./HBTableBody"));
var _HBTablePagination = _interopRequireDefault(require("./HBTablePagination"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _testIdBoundary = require("../common/providers/test-id-boundary.provider");
var _useSyncElementDimension = _interopRequireDefault(require("../common/useSyncElementDimension"));
var _HBTableHeader = _interopRequireDefault(require("./HBTableHeader"));
var _HBTableFloatingScroller = _interopRequireDefault(require("./HBTableFloatingScroller"));
var _HBTableFloatingBulkActions = _interopRequireDefault(require("./HBTableFloatingBulkActions"));
var _reactTable = require("@tanstack/react-table");
var _HBTableDndProvider = _interopRequireDefault(require("./HBTableDndProvider"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/** @deprecated WIP, do not use */
function HBTable(props) {
  var _useSyncElementDimens = (0, _useSyncElementDimension["default"])({
      dimension: 'width'
    }),
    sourceEl = _useSyncElementDimens.sourceEl,
    setSourceEl = _useSyncElementDimens.setSourceEl,
    setTargetEl = _useSyncElementDimens.setTargetEl;
  var table = useTable(props);
  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBTableHeader["default"], {
    table: table,
    tableBodyEl: sourceEl
  }), table.options.meta.helper.isEmptyState ? /*#__PURE__*/_react["default"].createElement(EmptyStateContainer, null, table.options.meta.emptyState) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBTableBody["default"], {
    table: table,
    setTableBodyEl: setSourceEl
  }), /*#__PURE__*/_react["default"].createElement(_HBTableFloatingBulkActions["default"], {
    table: table
  }), /*#__PURE__*/_react["default"].createElement(_HBTableFloatingScroller["default"], {
    setScrollerEl: setTargetEl
  }), /*#__PURE__*/_react["default"].createElement(_HBTablePagination["default"], {
    table: table
  })));
  return /*#__PURE__*/_react["default"].createElement(_testIdBoundary.TestIdBoundaryProvider, {
    prefix: table.options.meta.testIdPrefix
  }, /*#__PURE__*/_react["default"].createElement(_reactScrollSync.ScrollSync, null, /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": "".concat(table.options.meta.testIdPrefix, "--container")
  }, props.isColumnDragAndDropEnabled ? /*#__PURE__*/_react["default"].createElement(_HBTableDndProvider["default"], {
    table: table,
    onColumnOrderChange: props.onColumnOrderChange
  }, content) : content)));
}
var _default = exports["default"] = HBTable;
function useTable(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    columns = _ref.columns,
    rowCount = _ref.rowCount,
    pageCount = _ref.pageCount,
    getRowId = _ref.getRowId,
    onRowClick = _ref.onRowClick,
    isLoading = _ref.isLoading,
    isInitialLoading = _ref.isInitialLoading,
    pagination = _ref.pagination,
    sorting = _ref.sorting,
    testIdPrefix = _ref.testIdPrefix,
    onPaginationChange = _ref.onPaginationChange,
    _onSortingChange = _ref.onSortingChange,
    isFirstColumnPinned = _ref.isFirstColumnPinned,
    isLastColumnPinned = _ref.isLastColumnPinned,
    isLastColumnFloating = _ref.isLastColumnFloating,
    bulkActions = _ref.bulkActions,
    search = _ref.search,
    setSearch = _ref.setSearch,
    filterElements = _ref.filterElements,
    allFilterLabels = _ref.allFilterLabels,
    clearAllFilters = _ref.clearAllFilters,
    isColumnDragAndDropEnabled = _ref.isColumnDragAndDropEnabled,
    emptyState = _ref.emptyState;
  var reactTableColumnDefinitions = (0, _react.useMemo)(function () {
    return columns.reduce(function (definitions, column) {
      var id = column.id;
      definitions[id] = {
        id: id,
        accessorKey: id,
        meta: {
          original: column
        }
      };
      return definitions;
    }, {});
  }, [columns]);
  var _useState = (0, _react.useState)(function () {
      return columns.map(function (column) {
        return column.id;
      });
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    columnOrder = _useState2[0],
    setColumnOrder = _useState2[1];
  (0, _react.useEffect)(function () {
    setColumnOrder(columns.map(function (column) {
      return column.id;
    }));
  }, [columns]);
  var reactTableColumns = (0, _react.useMemo)(function () {
    return columnOrder.map(function (id) {
      return reactTableColumnDefinitions[id];
    }).filter(Boolean);
  }, [reactTableColumnDefinitions, columnOrder]);
  var _useRef = (0, _react.useRef)(new TableHelper(function () {
      return table;
    })),
    helper = _useRef.current;
  var table = (0, _reactTable.useReactTable)({
    data: data,
    columns: reactTableColumns,
    rowCount: rowCount,
    pageCount: pageCount,
    getRowId: getRowId,
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    onPaginationChange: onPaginationChange,
    onSortingChange: function onSortingChange(updater) {
      _onSortingChange(function (prev) {
        return typeof updater === 'function' ? updater([prev])[0] : updater[0];
      });
    },
    manualPagination: true,
    manualSorting: true,
    state: {
      pagination: pagination,
      sorting: [sorting],
      columnOrder: columnOrder
    },
    onColumnOrderChange: setColumnOrder,
    meta: {
      isLoading: isLoading,
      isInitialLoading: isInitialLoading,
      testIdPrefix: testIdPrefix,
      onRowClick: onRowClick,
      isFirstColumnPinned: isFirstColumnPinned,
      isLastColumnPinned: isLastColumnPinned,
      isLastColumnFloating: isLastColumnFloating,
      bulkActions: bulkActions,
      search: search,
      setSearch: setSearch,
      helper: helper,
      filterElements: filterElements,
      clearAllFilters: clearAllFilters,
      allFilterLabels: allFilterLabels,
      isColumnDragAndDropEnabled: isColumnDragAndDropEnabled,
      emptyState: emptyState
    }
  });
  return table;
}
var TableHelper = /*#__PURE__*/function () {
  function TableHelper(getTable) {
    (0, _classCallCheck2["default"])(this, TableHelper);
    this.getTable = getTable;
  }
  return (0, _createClass2["default"])(TableHelper, [{
    key: "table",
    get: function get() {
      return this.getTable();
    }
  }, {
    key: "isEmptyState",
    get: function get() {
      var _this$table$options$m;
      return this.table.getRowModel().rows.length === 0 && !((_this$table$options$m = this.table.options.meta) !== null && _this$table$options$m !== void 0 && _this$table$options$m.isLoading);
    }
  }, {
    key: "isSomeRowSelected",
    get: function get() {
      return this.table.getIsSomeRowsSelected();
    }
  }, {
    key: "isTableRowSelected",
    value: function isTableRowSelected(row) {
      var _this$table$getState = this.table.getState(),
        rowSelection = _this$table$getState.rowSelection;
      var isInRowIdList = row.id in rowSelection;
      return rowSelection.all ? !isInRowIdList : isInRowIdList;
    }
  }, {
    key: "toggleTableRowSelection",
    value: function toggleTableRowSelection(row, newSelected) {
      var newState = newSelected !== null && newSelected !== void 0 ? newSelected : !this.isTableRowSelected(row);
      var _this$table$getState2 = this.table.getState(),
        rowSelection = _this$table$getState2.rowSelection;
      row.toggleSelected(rowSelection.all ? !newState : newState);
    }
  }]);
}(); // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTable__Container",
  componentId: "sc-1cxqxt4-0"
})(["display:flex;flex-direction:column;background-color:", ";border:1px solid ", ";border-radius:6px;"], _colors["default"].white, _colors["default"].neutral300);
var EmptyStateContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTable__EmptyStateContainer",
  componentId: "sc-1cxqxt4-1"
})(["display:grid;place-content:center;padding:32px 16px;"]);
//# sourceMappingURL=HBTable.js.map